import type React from 'react';

interface NevadaSvgProps {
    color?: string;
    opacity?: number;
}

const NevadaSvg: React.FC<NevadaSvgProps> = ({ color = '#D91667', opacity = 0.5 }) => (
    <svg width="34" height="50" viewBox="0 0 34 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity={opacity}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8257 3.38631C23.5212 4.10031 32.9123 5.30189 32.9123 5.30189L28.3857 41.3019L28.1594 41.7547L27.7067 42.6604H27.0277L26.8014 41.7547L26.3488 41.9811L25.6698 41.5283L24.7645 41.9811L24.5381 42.8868L24.7645 43.566L24.5381 44.0189L24.7645 45.1509L24.5381 45.8302L24.7645 46.9623V47.8679L24.3118 48.0943V49L1 19.3396L4.39492 1C4.39492 1 14.0909 2.66635 18.8257 3.38631Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.8257 3.38631C23.5212 4.10031 32.9123 5.30189 32.9123 5.30189L28.3857 41.3019L28.1594 41.7547L27.7067 42.6604H27.0277L26.8014 41.7547L26.3488 41.9811L25.6698 41.5283L24.7645 41.9811L24.5381 42.8868L24.7645 43.566L24.5381 44.0189L24.7645 45.1509L24.5381 45.8302L24.7645 46.9623V47.8679L24.3118 48.0943V49L1 19.3396L4.39492 1C4.39492 1 14.0909 2.66635 18.8257 3.38631Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
    </svg>
);

export default NevadaSvg;
